import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 14 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M4.667 11c-.299 0-.598-.12-.825-.358l-3.5-3.667A1.25 1.25 0 0 1 0 6.111c0-.313.114-.626.342-.864a1.13 1.13 0 0 1 1.65 0L4.667 8.05 12.008.358a1.13 1.13 0 0 1 1.65 0c.228.239.342.552.342.864 0 .313-.114.626-.342.865l-8.166 8.555a1.14 1.14 0 0 1-.825.358"
    }, null, -1)
  ]))]))
}
export default { render: render }